import { render, staticRenderFns } from "./DailyCosts.vue?vue&type=template&id=f6bd987e"
import script from "./DailyCosts.vue?vue&type=script&lang=js"
export * from "./DailyCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports